function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.754 3.598a.622.622 0 01.184.442v10.808c0 .345-.28.625-.626.625H1.688a.625.625 0 01-.625-.625V1.723c0-.345.28-.625.625-.625h8.308c.165 0 .324.066.441.183l2.317 2.317z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.25 5.643l.677.676a.31.31 0 00.246.09.31.31 0 00.229-.129L5.75 4.393m2.188 1.08h2.5M3.25 8.768l.677.676a.31.31 0 00.246.09.31.31 0 00.229-.129L5.75 7.518m2.188 1.08h2.5M3.25 11.893l.677.676a.31.31 0 00.246.09.31.31 0 00.229-.129l1.348-1.887m2.188 1.08h2.5"
}));

function SvgGeneral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16
  }, props), _ref);
}

export default SvgGeneral;